export default __webpack_public_path__ + "static/media/bg2.533fc352.jpg";